import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Droplets } from 'lucide-react';

const SplashScreen = () => {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
    const timer = setTimeout(() => {
      navigate('/auth');
    }, 2500);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-sonangol-red to-sonangol-orange flex flex-col items-center justify-center relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      {/* Logo and content */}
      <div className={`relative z-10 text-center transition-all duration-1000 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="mb-8">
          <div className="w-24 h-24 mx-auto bg-white rounded-2xl flex items-center justify-center shadow-2xl mb-6">
            <Droplets className="w-14 h-14 text-sonangol-red" />
          </div>
          <h1 className="font-barlow text-5xl font-bold text-white tracking-tight uppercase">
            HáLubri
          </h1>
          <p className="text-white/80 mt-2 font-manrope text-lg">
            SONANGOL
          </p>
        </div>
        
        <p className="text-white/70 font-manrope text-sm max-w-xs mx-auto">
          O lubrificante certo para o seu motor, entregue à sua porta.
        </p>
        
        {/* Loading indicator */}
        <div className="mt-12 flex justify-center">
          <div className="w-12 h-1 bg-white/30 rounded-full overflow-hidden">
            <div className="h-full bg-white rounded-full animate-[loading_2s_ease-in-out_infinite]" 
                 style={{ animation: 'loading 2s ease-in-out' }}></div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <div className="absolute bottom-8 text-white/50 text-xs font-manrope">
        © 2025 Sonangol E.P.
      </div>
      
      <style>{`
        @keyframes loading {
          0% { width: 0%; }
          100% { width: 100%; }
        }
      `}</style>
    </div>
  );
};

export default SplashScreen;
